"use client"

import { cn } from "@/lib/utils"
import {
  CoverageForm,
  type CoverageTone,
} from "@/components/insurance/coverage-form"
import type { InsurerData } from "@/lib/insurance/insurance-types"

/**
 * Shared entry point for the native insurance coverage checker.
 *
 * Wraps {@link CoverageForm} with the loading skeleton shown while the
 * server-fetched insurer/coverage data is unavailable (CMS unreachable at
 * build time). Used by the /insurance page and the /go/insurance* landing
 * pages so they all render the same migrated form instead of the retired
 * insurance.aheadhealth.com web-component embed.
 */
export function CoverageChecker({
  data,
  tone = "default",
  initialInsurerId,
}: {
  data: InsurerData | null
  /** `tinted` = white card with a soft shadow, neutral-50 options inside. */
  tone?: CoverageTone
  /** Pre-select an insurer (per-insurer pages). */
  initialInsurerId?: string
}) {
  if (!data) {
    return (
      <div
        className={cn(
          "mx-auto h-[480px] max-w-[760px] animate-pulse rounded-2xl",
          tone === "tinted" ? "shadow-[0_1px_8px_rgba(0,0,0,0.04)]" : "",
          "bg-white"
        )}
      />
    )
  }
  return (
    <CoverageForm
      data={data}
      embedded
      tone={tone}
      initialInsurerId={initialInsurerId}
    />
  )
}
